<template>
  <div>
    <div class="_footerBox_a30j0_30 footer-box">
      <div class="_assembly-box_14aph_30 assembly-box">
        <div class="link-list-box _link-list-box_1gpjz_30 _verticalBox_1gpjz_55 vertical-box">
          <div class="_textlink-box_1gpjz_35 textlink-box" data-columns="3">
            <div class="_item-box_1gpjz_35 textlink-item">
              <div class="_title_1gpjz_35 link-list-title">娱乐城</div>
              <div class="_item-list_1gpjz_40 item-list">
                <div class="_item_1gpjz_35 link-list-item">任务</div>
                <div class="_item_1gpjz_35 link-list-item">待领取</div>
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/vip')">VIP</div>
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/fanshui')">推广赚钱</div>
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/activity')">活动</div>
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/fanshui')">返水</div>
              </div>
            </div>
            <div class="_item-box_1gpjz_35 textlink-item">
              <div class="_title_1gpjz_35 link-list-title">游戏</div>
              <div class="_item-list_1gpjz_40 item-list">
                <div class="_item_1gpjz_35 link-list-item">热门</div>
                <div class="_item_1gpjz_35 link-list-item">真人</div>
                <div class="_item_1gpjz_35 link-list-item">电子</div>
                <div class="_item_1gpjz_35 link-list-item">棋牌</div>
                <div class="_item_1gpjz_35 link-list-item">捕鱼</div>
                <div class="_item_1gpjz_35 link-list-item">体育</div>
                <div class="_item_1gpjz_35 link-list-item">斗鸡</div>
                <div class="_item_1gpjz_35 link-list-item">彩票</div>
                <div class="_item_1gpjz_35 link-list-item">区块链</div>
              </div>
            </div>
            <div class="_item-box_1gpjz_35 textlink-item">
              <div class="_title_1gpjz_35 link-list-title">支持</div>
              <div class="_item-list_1gpjz_40 item-list">
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/kefu')">在线客服</div>
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/kefu')">帮助中心</div>
                <div class="_item_1gpjz_35 link-list-item" @click="$parent.goNav('/boutBallBet')">有奖反馈</div>
              </div>
            </div>
          </div>
          <div class="_license-compliance_ablfx_30 license-compliance">
            <div class="_title_ablfx_30">牌照合规</div>
            <div class="_license-compliance-list_ablfx_35">
              <!----><img
                class="lobby-image lobby-image"
                data-load-strategy="loading-set@1:lazy@0"
                data-status="success"
                data-thumb="0"
                data-id="ffc51a28-1ad4-4664-b74c-d8a49384c2d1"
                src="https://xd55.vip/siteadmin/skin/lobby_asset/common/common/common/18plus.avif?manualVersion=1&amp;version=10fea753dc"
                alt="."
                style="width: 0.9rem; height: 0.9rem;"
              /><!---->
            </div>
          </div>
        </div>
        <div class="_channel-box_1tgxg_30 channel-box">
          <span class="_title_1tgxg_36">官方频道</span>
          <div class="_channel-items_1tgxg_42 channel-items">
            <div class="_channel-item_1tgxg_42 channel-item">
              <img class="lobby-image lobby-image" data-load-strategy="loading-set@1:lazy@0" data-status="success" data-thumb="0" data-id="f927e4b8-ef27-46a2-88b7-77834a1bdec7" src="https://xd22.vip/siteadmin/officialcommunity/img_gfpd_telegram.png" alt="." style="width: 100%; height: 100%;" />
            </div>
          </div>
        </div>
        <div class="ui-placeholder ui-placeholder--container _contactus-box_18kto_43 contactus-box">
          <!---->
          <div>
            <div class="_contact-us-title_18kto_54 contact-us-title">联系我们</div>
            <div class="_contactUs_18kto_30 contact-us">
              <div class="_socialItem_18kto_36">
                <img class="lobby-image lobby-image" data-load-strategy="loading-set@1:lazy@0" data-status="success" data-thumb="0" data-id="3184a6ad-aa5c-4a17-be7a-363c8e24abf3" src="https://xd55.vip/siteadmin/upload/img/telegram.avif" alt="开云娱乐客服" style="width: 0.7rem; height: 0.7rem;" />
              </div>
              <!---->
            </div>
          </div>
        </div>
        <div class="_mixin-text_1yte4_30 footer-mixin-text">
          <div class="">
            <div>
              <div style="text-align: center; font-size: 0.24rem; line-height: 1.6; color: #666666;">
                <p>
                  开云娱乐是国际最知名的线上博彩运营公司，为大家提供刺激好玩的真人荷官娱乐城、棋牌、电子、捕鱼、彩票、体育等全品类游戏；千万资金秒下分，上下分无忧；24小时客服Telegram账号<span style="color: #e03e2d;">
                    <strong
                      ><span style="background-color: #ffffff;"
                        ><a style="color: #e03e2d; background-color: #ffffff;" href="https://t.me/xdvip" target="_blank" data-jump="1"><span style="color: #008000;">@xdvip</span></a></span
                      ></strong
                    ></span
                  >
                </p>
              </div>
              <div style="text-align: center;">
                <a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898028847159623681.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028847159623681.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898028876860772353.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028876860772353.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898028918005776386.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028918005776386.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898028941653094402.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028941653094402.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898028962747535362.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028962747535362.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898028983284523009.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898028983284523009.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"
                /></a>
              </div>
              <div style="text-align: center;">
                <a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898029702228766722.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898029702228766722.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898030460586737666.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898030460586737666.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898030547513786370.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898030547513786370.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"/></a
                ><a target="_blank" data-jump="1"
                  ><img
                    style="margin-right: 0.1rem; margin-bottom: 0.2rem; max-width: 100%; opacity: 1; width: 1rem;"
                    src="https://xd55.vip/siteadmin/upload/img/1898030596835790849.png"
                    onerror="this.onerror=null;this.src='https://byg7tf-1668-ppp.s3.ap-east-1.amazonaws.com/siteadmin/upload/img/1898030596835790849.png';"
                    onload="this.style.width = this.naturalWidth/100 + 'rem';  this.style.opacity = '1';"
                /></a>
              </div>
              <div style="display: flex; align-items: center; justify-content: center; font-size: 0.18rem; color: #55657e; text-align: center;">
                <div style="width: calc((100% - 0.11rem) / 2); padding: 0 0.15rem; white-space: normal; word-break: break-all; text-align: center; color: #999999; ;width: calc((100% - 0.11rem) / 2);">
                  <p>本站面向海外用户，只支持美金和USDT充值，不支持人民币充值，请中国用户不要违法赌博。</p>
                </div>
                <div style="display: inline-block; height: 1em; margin: 0 0.05rem; position: relative; vertical-align: middle; width: 0.01rem; background: #E3E3E3;">&nbsp;</div>
                <div style="width: calc((100% - 0.11rem) / 2); padding: 0 0.15rem; white-space: normal; word-break: break-all; text-align: center; color: #999999; ;width: calc((100% - 0.11rem) / 2);">
                  <p>@开云娱乐版权所有 2002-2025</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  created() {},
};
</script>
<style lang="scss" scoped>
._home-layout_x27ue_30 ._main_x27ue_33>div {
    margin-top: .2rem;
}
._footerBox_a30j0_30 {
    padding: .2rem .2rem .4rem;
    background-color: #f8f8f8;
}
._link-list-box_1gpjz_30 {
    margin-bottom: .3rem;
    padding-bottom: .3rem;
    border-bottom: thin solid #e3e3e3;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 {
    display: flex
;
    flex-wrap: wrap;
    row-gap: .1rem;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 {
    overflow: hidden;
    width: 33.33%;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._title_1gpjz_35 {
    margin-bottom: .2rem;
}
._link-list-box_1gpjz_30 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._title_1gpjz_35 {
    margin-bottom: .2rem;
    color: var(--skin__neutral_2);
    font-size: .26rem;
}
._link-list-box_1gpjz_30 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._item-list_1gpjz_40 ._item_1gpjz_35 {
    margin-bottom: .2rem;
    color: #666666;
    font-size: .24rem;
}
._verticalBox_1gpjz_55 ._textlink-box_1gpjz_35 ._item-box_1gpjz_35 ._item_1gpjz_35 {
    margin-bottom: .1rem;
    color: var(--skin__neutral_1);
    font-size: .16rem;
    max-width: 2.2rem;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
._link-list-box_1gpjz_30 .license-compliance {
    margin-top: .4rem;
}
._license-compliance_ablfx_30 ._title_ablfx_30 {
    margin-bottom: .3rem;
    color:#999;
    font-size: .26rem;
}
._license-compliance_ablfx_30 ._license-compliance-list_ablfx_35{
    display: flex;
    gap: .5rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}
._channel-box_1tgxg_30 {
    width: 100%;
    margin-bottom: .3rem;
    padding-bottom: .1rem;
    border-bottom: thin solid #e3e3e3;
}
._channel-box_1tgxg_30 ._title_1tgxg_36 {
    margin-bottom: .2rem;
    display: inline-block;
    color:#999;
    font-size: .26rem;
}
._channel-box_1tgxg_30 ._channel-items_1tgxg_42 {
    display: flex;
    flex-wrap: wrap;
    gap: .2rem;
    padding-bottom: .3rem;
    box-sizing: content-box;
}
._channel-box_1tgxg_30 ._channel-items_1tgxg_42 ._channel-item_1tgxg_42 {
    width: .7rem;
    height: .7rem;
}
._contactus-box_18kto_43 {
    border-bottom: thin solid #e3e3e3;
    padding-bottom: .3rem;
    margin-bottom: .3rem;
}
._contact-us-title_18kto_54 {
    margin-bottom: .2rem;
    color: #999;
    font-weight: 400;
    font-size: .26rem;
}
._contactUs_18kto_30 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: .2rem;
}
._contactUs_18kto_30 ._socialItem_18kto_36 {
    color: inherit;
}
._contactUs_18kto_30 ._socialItem_18kto_36 img {
    display: block;
    max-width: 100%;
}
.link-list-title{
  color: #999999!important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/indexBo.vue